import React, { forwardRef } from 'react';
import { Search, X } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Input } from './Input';
import { Button } from './Button';

const SearchInput = forwardRef(({
  className,
  placeholder = "Search...",
  value,
  onChange,
  onClear,
  ...props
}, ref) => {
  return (
    <div className="relative group w-full">
      <Search className="absolute left-5 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400 group-focus-within:text-slate-900 transition-colors pointer-events-none" />
      <Input
        ref={ref}
        type="text"
        className={cn(
          "w-full h-10 pl-14 pr-12 bg-background border border-input rounded-lg text-sm font-medium placeholder:text-muted-foreground focus-visible:ring-1 focus-visible:ring-ring focus-visible:border-input transition-all shadow-sm",
          className
        )}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...props}
      />
      {value && onClear && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="absolute right-4 top-1/2 -translate-y-1/2 h-8 w-8 hover:bg-slate-100 rounded-xl text-slate-400 hover:text-slate-900 transition-colors"
          onClick={onClear}
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
});

SearchInput.displayName = "SearchInput";

export { SearchInput };
